const accountBehaviorIds = {
    ShowPreviousChildren: 'ShowPreviousChildren',
    NotificationEnabled: 'NotificationEnabled',
    ConversationEnabled: 'ConversationEnabled',
    ConversationShowStarTab: 'ConversationShowStarTab',
    ConversationShowAllTab: 'ConversationShowAllTab',
    ShowNewPost: 'ShowNewPost',
    ShowNewObservation: 'ShowNewObservation',
    ShowObservations2021Revision: 'ShowObservations2021Revision',
    ShowObservationsPre2021Revision: 'ShowObservationsPre2021Revision',
    CanSignChildrenInWithGPS: 'CanSignChildrenInWithGPS',
    CanSignEmployeesInWithGPS: 'CanSignEmployeesInWithGPS',
    CanNotChangeAddress: 'CanNotChangeAddress',
    ShouldSetPassword: 'ShouldSetPassword',
    CanListPaymentSources: 'CanListPaymentSources',
    ShouldReplyToNps: 'ShouldReplyToNps',
    HasTwoFactorAuthentication: 'HasTwoFactorAuthentication',
    CanActivateTwoFactorAuthentication: 'CanActivateTwoFactorAuthentication',
    ToursAvailable: 'ToursAvailable',
    ScaleImagesBeforeUploading: 'ScaleImagesBeforeUploading',
    UseUserContextAuthentication: 'UseUserContextAuthentication',
    EnableElevio: 'EnableElevio',
    CanLinkToActivityInPost: 'CanLinkToActivityInPost',
    CanStartFamlyLiveMeetings: 'CanStartFamlyLiveMeetings',
    WhiteLabelInfo: 'WhiteLabelInfo',
    CanJoinFamlyLiveMeetingsFromWeb: 'CanJoinFamlyLiveMeetingsFromWeb',
    CanJoinFamlyLiveMeetingsFromAndroid: 'CanJoinFamlyLiveMeetingsFromAndroid',
    CanJoinFamlyLiveMeetingsFromIOs: 'CanJoinFamlyLiveMeetingsFromIOs',
    CanUnsubscribeFromOrgSender: 'CanUnsubscribeFromOrgSender',
    ShowWarningOnPostToManyRecipients: 'ShowWarningOnPostToManyRecipients',
    RestrictTaggingMedia: 'RestrictTaggingMedia',
    CanChangeLoginEmail: 'CanChangeLoginEmail',
    CanEditAccount: 'CanEditAccount',
    ShowActiveTrialSubscriptions: 'ShowActiveTrialSubscriptions',
    ShowOverduePaymentBanner: 'ShowOverduePaymentBanner',
    IsFreePackageEmployee: 'IsFreePackageEmployee',
    DoorlockingEnabled: 'DoorlockingEnabled',
    ShowProfileWarning: 'ShowProfileWarning',
};

export default accountBehaviorIds;
